import { post } from './base'
import { apiUri } from '../api/api_default'

export const getRealtimeRateTable = (params = {}) => post(apiUri.getRealtimeRateTable)
